var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplatesFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8957 3H4.23478C3.55283 3 3 3.55283 3 4.23478V19.9391C3 21.6296 4.3704 23 6.06087 23H19.0696C20.76 23 22.1304 21.6296 22.1304 19.9391V4.23478C22.1304 3.55283 21.5776 3 20.8957 3ZM4.73828 4.73913H20.3905L20.3913 19.9391C20.3913 20.6691 19.7996 21.2609 19.0696 21.2609H6.06089L5.94058 21.2555C5.26699 21.1947 4.73915 20.6286 4.73915 19.9391L4.73828 4.73913Z",
    fill: "#EE5B3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4345 6.47852H7.69542C7.02307 6.47852 6.47803 7.02356 6.47803 7.69591V11.2611C6.47803 11.7414 6.86734 12.1307 7.34759 12.1307H17.7824C18.2626 12.1307 18.6519 11.7414 18.6519 11.2611V7.69591C18.6519 7.02356 18.1069 6.47852 17.4345 6.47852ZM16.912 8.21764V10.3915H8.2163V8.21764H16.912Z",
    fill: "#EE5B3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.565 13.8691C13.0452 13.8691 13.4345 14.2585 13.4345 14.7387C13.4345 15.1847 13.0989 15.5522 12.6664 15.6024L12.565 15.6083H7.34759C6.86734 15.6083 6.47803 15.219 6.47803 14.7387C6.47803 14.2928 6.81371 13.9252 7.24618 13.875L7.34759 13.8691H12.565Z",
    fill: "#EE5B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesFooter);
export default __webpack_public_path__ + "static/media/templatesFooter.e59272fd3d4ba6628be31d23b0d4b91f.svg";
export { ForwardRef as ReactComponent };